import { Route } from '@angular/router';
import { MainLayoutComponent } from './layout/app-layout/main-layout/main-layout.component';
import { AuthGuard } from '@core/guard/auth.guard';
import { AuthLayoutComponent } from './layout/app-layout/auth-layout/auth-layout.component';
import {InscLayoutComponent } from './inscription/inscription.component';
import { Page404Component } from './authentication/page404/page404.component';
import { LandingComponent } from './landing/landing.component';
import { Role } from '@core';

export const APP_ROUTE: Route[] = [
  {
    path: '',
    component: LandingComponent,
  },
  {
    path: 'home',
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: '/admin', pathMatch: 'full' },

      {
        path: 'admin',
        canActivate: [AuthGuard],
        data: {
          role: [Role.Admin, Role.SchoolDirector],
        },
        loadChildren: () =>
          import('./admin/admin.routes').then((m) => m.ADMIN_ROUTE),
      },
      {
        path: 'teacher',
        canActivate: [AuthGuard],
        data: {
          role: Role.Teacher,
        },
        loadChildren: () =>
          import('./teacher/teacher.routes').then((m) => m.TEACHER_ROUTE),
      },
      {
        path: 'parent',
        canActivate: [AuthGuard],
        data: {
          role: Role.Parent,
        },
        loadChildren: () =>
          import('./parent/parent.routes').then((m) => m.PARENT_ROUTE),
      },
      {
        path: 'student',
        canActivate: [AuthGuard],
        data: {
          role: Role.Student,
        },
        loadChildren: () =>
          import('./student/student.routes').then((m) => m.STUDENT_ROUTE),
      },
      {
        path: 'doctor',
        canActivate: [AuthGuard],
        data: {
          role: Role.Doctor,
        },
        loadChildren: () =>
          import('./doctor/doctor.routes').then((m) => m.DOCTOR_ROUTE),
      },
      {
        path: 'calendar',
        canActivate: [AuthGuard],
        data: {
          role: [Role.Admin, Role.SchoolDirector, Role.Teacher, Role.Student, Role.Parent, Role.Doctor, Role.All],
        },
        loadChildren: () =>
          import('./calendar/calendar.routes').then((m) => m.CALENDAR_ROUTE),
      },
      {
        path: 'task',
        canActivate: [AuthGuard],
        data: {
          role: [Role.Admin, Role.SchoolDirector, Role.Teacher, Role.Student, Role.Parent, Role.Doctor, Role.All],
        },
        loadChildren: () =>
          import('./task/task.routes').then((m) => m.TASK_ROUTE),
      },
      {
        path: 'contacts',
        canActivate: [AuthGuard],
        data: {
          role: [Role.Admin, Role.SchoolDirector, Role.Teacher, Role.Student, Role.Parent, Role.Doctor, Role.All],
        },
        loadChildren: () =>
          import('./contacts/contacts.routes').then((m) => m.CONTACT_ROUTE),
      },
      {
        path: 'email',
        canActivate: [AuthGuard],
        data: {
          role: [Role.Admin, Role.SchoolDirector, Role.Teacher, Role.Student, Role.Parent, Role.Doctor, Role.All],
        },
        loadChildren: () =>
          import('./email/email.routes').then((m) => m.EMAIL_ROUTE),
      },
      {
        path: 'apps',
        canActivate: [AuthGuard],
        data: {
          role: [Role.Admin, Role.SchoolDirector, Role.Teacher, Role.Student, Role.Parent, Role.Doctor, Role.All],
        },
        loadChildren: () =>
          import('./apps/apps.routes').then((m) => m.APPS_ROUTE),
      },
      {
        path: 'widget',
        canActivate: [AuthGuard],
        data: {
          role: [Role.Admin, Role.SchoolDirector, Role.Teacher, Role.Student, Role.Parent, Role.Doctor, Role.All],
        },
        loadChildren: () =>
          import('./widget/widget.routes').then((m) => m.WIDGET_ROUTE),
      },
      {
        path: 'ui',
        canActivate: [AuthGuard],
        data: {
          role: [Role.Admin, Role.SchoolDirector, Role.Teacher, Role.Student, Role.Parent, Role.Doctor, Role.All],
        },
        loadChildren: () => import('./ui/ui.routes').then((m) => m.UI_ROUTE),
      },
      {
        path: 'forms',
        canActivate: [AuthGuard],
        data: {
          role: [Role.Admin, Role.SchoolDirector, Role.Teacher, Role.Student, Role.Parent, Role.Doctor, Role.All],
        },
        loadChildren: () =>
          import('./forms/forms.routes').then((m) => m.FORMS_ROUTE),
      },
      {
        path: 'tables',
        canActivate: [AuthGuard],
        data: {
          role: [Role.Admin, Role.SchoolDirector, Role.Teacher, Role.Student, Role.Parent, Role.Doctor, Role.All],
        },
        loadChildren: () =>
          import('./tables/tables.routes').then((m) => m.TEBLES_ROUTE),
      },
      {
        path: 'charts',
        canActivate: [AuthGuard],
        data: {
          role: [Role.Admin, Role.SchoolDirector, Role.Teacher, Role.Student, Role.Parent, Role.Doctor, Role.All],
        },
        loadChildren: () =>
          import('./charts/charts.routes').then((m) => m.CHART_ROUTE),
      },
      {
        path: 'timeline',
        canActivate: [AuthGuard],
        data: {
          role: [Role.Admin, Role.SchoolDirector, Role.Teacher, Role.Student, Role.Parent, Role.Doctor, Role.All],
        },
        loadChildren: () =>
          import('./timeline/timeline.routes').then((m) => m.TIMELINE_ROUTE),
      },
      {
        path: 'icons',
        canActivate: [AuthGuard],
        data: {
          role: [Role.Admin, Role.SchoolDirector, Role.Teacher, Role.Student, Role.Parent, Role.Doctor, Role.All],
        },
        loadChildren: () =>
          import('./icons/icons.routes').then((m) => m.ICONS_ROUTE),
      },
      {
        path: 'extra-pages',
        canActivate: [AuthGuard],
        data: {
          role: [Role.Admin, Role.SchoolDirector, Role.Teacher, Role.Student, Role.Parent, Role.Doctor, Role.All],
        },
        loadChildren: () =>
          import('./extra-pages/extra-pages.routes').then(
            (m) => m.EXTRA_PAGES_ROUTE
          ),
      },
      {
        path: 'maps',
        canActivate: [AuthGuard],
        data: {
          role: [Role.Admin, Role.SchoolDirector, Role.Teacher, Role.Student, Role.Parent, Role.Doctor, Role.All],
        },
        loadChildren: () =>
          import('./maps/maps.routes').then((m) => m.MAPS_ROUTE),
      },
      {
        path: 'multilevel',
        canActivate: [AuthGuard],
        data: {
          role: [Role.Admin, Role.SchoolDirector, Role.Teacher, Role.Student, Role.Parent, Role.Doctor, Role.All],
        },
        loadChildren: () =>
          import('./multilevel/multilevel.routes').then(
            (m) => m.MULTILEVEL_ROUTE
          ),
      },
    ],
  },
  {
    path: 'authentication',
    component: AuthLayoutComponent,
    loadChildren: () =>
      import('./authentication/auth.routes').then((m) => m.AUTH_ROUTE),
  },
  {
    path: 'inscription',
    component: InscLayoutComponent,
    loadChildren: () =>
      import('./inscription/insc.routes').then((m) => m.AUTH_ROUTE),
  },
  { path: '**', component: Page404Component },
];
